import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../components'
import UserActivationToggle from './UserActivationToggle'
import UserRightsSlider from './UserRightsSlider'
import ChangeUserRolePane from './ChangeUserRolePane'
import {LoginAsButton} from "./LoginAsButton";

const UserDataGridRowStyle = (user, rowIndex) => {
  const style = {}
  if (user.is_active) {
    style.borderLeft = user.is_superuser
      ? '10px solid black'
      : '10px solid green'
  } else {
    style.borderLeft = '10px solid red'
  }

  return style
}

export const UsersDataGrid = ({
  results,
  page_size,
  current,
  count,
  onFilter,
  handleTableChange,
  children,
  hiddenRowKeys,
}) => {
  const actionFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
      <ReactBootstrap.Dropdown>
        <ReactBootstrap.Dropdown.Toggle
          variant="dark"
          size="sm"
        ></ReactBootstrap.Dropdown.Toggle>
        <ReactBootstrap.Dropdown.Menu>
          <UserActivationToggle onChange={onFilter} user={row} />
          <UserRightsSlider buttonType="dropdown" user={row} />
          <ChangeUserRolePane
            onChange={onFilter}
            buttonType="dropdown"
            user={row}
          />
          <LoginAsButton
            user={row}
          />
        </ReactBootstrap.Dropdown.Menu>
      </ReactBootstrap.Dropdown>
    )
  }

  const columns = [
    {
      dataField: 'full_name',
      text: 'Name',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'email',
      text: 'User Email',

      type: 'string',
      searchFieldType: 'email',
    },
    {
      dataField: 'role',
      text: 'Role',
      type: 'string',
    },

    {
      dataField: 'contact_number',
      text: 'Contact Number',
      hidden: true,

      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'gsx_user_name',
      text: 'GSX User Name',
      hidden: true,

      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'gsx_technician_id',
      text: 'GSX Technician ID',
      hidden: true,

      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'is_active',
      text: 'Status',
      formatter: components.BooleanFormatterWithCSS('is_active', 'text-left'),
    },
    {
      dataField: 'date_joined',
      text: 'Date Joined',
      type: 'string',
      formatter: components.CellDateFormatter,
      searchFieldType: 'date',
    },
    {
      dataField: 'url',
      text: 'Change Log',
      formatter: components.ChangeLogFormatter,
    },
    {
      dataField: '',
      text: '',

      formatter: actionFormatter,
    },
  ]
  return (
    <ReactBootstrap.Card>
      <ReactBootstrap.Card.Header className="card-header bg-dark text-white">
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs={6}>Users</ReactBootstrap.Col>
          <ReactBootstrap.Col className="text-white text-end" xs={6}>
            <components.Slider
                   sliderWidth={"20vw"}
              size="sm"
              title={components.ICONS.SEARCH}
              header={
                <span className="pr-3">
                  {components.ICONS.SEARCH}
                  <span className="pl-1"> Users</span>
                </span>
              }
            >
              <components.GenericSearchForm
                onFilter={onFilter}
                columns={columns}
              />
            </components.Slider>
            {children}
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </ReactBootstrap.Card.Header>
      <ReactBootstrap.Card.Body>
        <components.DataGrid
          rowStyle={UserDataGridRowStyle}
          keyField="url"
          data={results || []}
          sizePerPage={page_size || 10}
          current={current || 1}
          page={current}
          columns={columns}
          count={count || 0}
          onTableChange={handleTableChange}
          hiddenRows={hiddenRowKeys}
        />
      </ReactBootstrap.Card.Body>
    </ReactBootstrap.Card>
  )
}
